import React, { useEffect, createElement } from 'react';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { ProductIntroSection } from './components/ProductIntroSection';
import { ModulesSection } from './components/ModulesSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FaqSection } from './components/FaqSection';
import { FinalCtaSection } from './components/FinalCtaSection';
import { FooterSection } from './components/FooterSection';
import { SocialProofNotifications } from './components/SocialProofNotifications';
export function App() {
  useEffect(() => {
    document.title = 'Vitality 360™ | At-Home Activity & Care Kit for Older Adults';
    const link = document.createElement('link');
    link.href = 'https://fonts.googleapis.com/css2?family=Inter:wght@400;700&family=Fraunces:opsz,wght@9..144,700&display=swap';
    link.rel = 'stylesheet';
    document.head.appendChild(link);
  }, []);
  return <div className="font-sans text-white bg-familia-bg min-h-screen selection:bg-familia-cyan selection:text-familia-bg" data-id="element-0" data-mp="3ikh829m9asyz">
      <SocialProofNotifications data-id="element-1" data-mp="3mkhnnxl3da7m" />
      <HeroSection data-id="element-2" data-mp="3mjgannkimdn9" />
      <PainSection data-id="element-3" data-mp="3rc9d24sih9w6" />
      <ProductIntroSection data-id="element-4" data-mp="3rbrbqtqzs5he" />
      <ModulesSection data-id="element-5" data-mp="3rdkh85pvcjnt" />
      <GuaranteeSection data-id="element-6" data-mp="3recf5n6xuth9" />
      <FaqSection data-id="element-7" data-mp="5yh2n2cyzbp" />
      <FinalCtaSection data-id="element-8" data-mp="6htjo98ovic" />
      <FooterSection data-id="element-9" data-mp="4n6a3ahwrb3" />
    </div>;
}